export default "__VITE_ASSET__BOTIePxG__"